import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center",
  style: {"min-height":"400px"}
}
const _hoisted_2 = {
  key: 1,
  class: "row"
}
const _hoisted_3 = { class: "col-xl-3 col-md-6" }
const _hoisted_4 = { class: "card card-animate" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = { class: "flex-shrink-0" }
const _hoisted_8 = { class: "text-success fs-14 mb-0" }
const _hoisted_9 = { class: "d-flex align-items-end justify-content-between mt-4" }
const _hoisted_10 = { class: "fs-22 fw-semibold ff-secondary mb-4" }
const _hoisted_11 = ["data-target"]
const _hoisted_12 = { class: "col-xl-3 col-md-6" }
const _hoisted_13 = { class: "card card-animate" }
const _hoisted_14 = { class: "card-body" }
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = { class: "flex-shrink-0" }
const _hoisted_17 = { class: "text-info fs-14 mb-0" }
const _hoisted_18 = { class: "d-flex align-items-end justify-content-between mt-4" }
const _hoisted_19 = { class: "fs-22 fw-semibold ff-secondary mb-4" }
const _hoisted_20 = ["data-target"]
const _hoisted_21 = { class: "col-xl-3 col-md-6" }
const _hoisted_22 = { class: "card card-animate" }
const _hoisted_23 = { class: "card-body" }
const _hoisted_24 = { class: "d-flex align-items-center" }
const _hoisted_25 = { class: "flex-shrink-0" }
const _hoisted_26 = { class: "text-warning fs-14 mb-0" }
const _hoisted_27 = { class: "d-flex align-items-end justify-content-between mt-4" }
const _hoisted_28 = { class: "fs-22 fw-semibold ff-secondary mb-4" }
const _hoisted_29 = ["data-target"]
const _hoisted_30 = { class: "col-xl-3 col-md-6" }
const _hoisted_31 = { class: "card card-animate" }
const _hoisted_32 = { class: "card-body" }
const _hoisted_33 = { class: "d-flex align-items-center" }
const _hoisted_34 = { class: "flex-shrink-0" }
const _hoisted_35 = { class: "text-danger fs-14 mb-0" }
const _hoisted_36 = { class: "d-flex align-items-end justify-content-between mt-4" }
const _hoisted_37 = { class: "fs-22 fw-semibold ff-secondary mb-4" }
const _hoisted_38 = ["data-target"]
const _hoisted_39 = { class: "col-xl-8" }
const _hoisted_40 = { class: "card" }
const _hoisted_41 = { class: "card-body" }
const _hoisted_42 = {
  ref: "paiementsChart",
  height: "300"
}
const _hoisted_43 = { class: "col-xl-4" }
const _hoisted_44 = { class: "card" }
const _hoisted_45 = { class: "card-body" }
const _hoisted_46 = {
  ref: "secteursChart",
  height: "300"
}
const _hoisted_47 = { class: "col-xl-6" }
const _hoisted_48 = { class: "card" }
const _hoisted_49 = { class: "card-body" }
const _hoisted_50 = {
  ref: "statutUsagersChart",
  height: "300"
}
const _hoisted_51 = { class: "col-xl-6" }
const _hoisted_52 = { class: "card" }
const _hoisted_53 = { class: "card-body" }
const _hoisted_54 = {
  ref: "activitesChart",
  height: "300"
}
const _hoisted_55 = { class: "col-xl-12" }
const _hoisted_56 = { class: "card" }
const _hoisted_57 = { class: "card-body" }
const _hoisted_58 = {
  ref: "marchesChart",
  height: "200"
}
const _hoisted_59 = { class: "col-xl-6" }
const _hoisted_60 = { class: "card" }
const _hoisted_61 = { class: "card-body" }
const _hoisted_62 = {
  ref: "paiementsUsagersChart",
  height: "300"
}
const _hoisted_63 = { class: "col-xl-6" }
const _hoisted_64 = { class: "card" }
const _hoisted_65 = { class: "card-body" }
const _hoisted_66 = {
  ref: "paiementsAmbulantsChart",
  height: "300"
}
const _hoisted_67 = { class: "col-xl-12" }
const _hoisted_68 = { class: "card" }
const _hoisted_69 = { class: "card-body" }
const _hoisted_70 = { class: "table-responsive" }
const _hoisted_71 = { class: "table table-bordered table-striped" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("div", { class: "text-center" }, [
          _createElementVNode("div", {
            class: "spinner-border text-primary",
            role: "status",
            style: {"width":"3rem","height":"3rem"}
          }, [
            _createElementVNode("span", { class: "visually-hidden" }, "Chargement...")
          ]),
          _createElementVNode("div", { class: "mt-3" }, [
            _createElementVNode("h5", { class: "text-muted" }, "Chargement des statistiques..."),
            _createElementVNode("p", { class: "text-muted" }, "Veuillez patienter pendant que nous récupérons les données.")
          ])
        ], -1)
      ]))]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex-grow-1 overflow-hidden" }, [
                  _createElementVNode("p", { class: "text-uppercase fw-medium text-muted text-truncate mb-0" }, "Total Usagers")
                ], -1)),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("h5", _hoisted_8, [
                    _cache[1] || (_cache[1] = _createElementVNode("i", { class: "ri-arrow-right-up-line fs-13 align-middle" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.stats.totalUsagers), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", null, [
                  _createElementVNode("h4", _hoisted_10, [
                    _createElementVNode("span", {
                      class: "counter-value",
                      "data-target": _ctx.stats.totalUsagers
                    }, _toDisplayString(_ctx.stats.totalUsagers), 9, _hoisted_11)
                  ]),
                  _cache[3] || (_cache[3] = _createElementVNode("span", { class: "badge bg-success-subtle text-success mb-0" }, [
                    _createElementVNode("i", { class: "ri-arrow-up-line align-middle" }),
                    _createTextVNode(" Actifs ")
                  ], -1))
                ]),
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "avatar-sm flex-shrink-0" }, [
                  _createElementVNode("span", { class: "avatar-title bg-success-subtle rounded fs-3" }, [
                    _createElementVNode("i", { class: "bx bx-user text-success" })
                  ])
                ], -1))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "flex-grow-1 overflow-hidden" }, [
                  _createElementVNode("p", { class: "text-uppercase fw-medium text-muted text-truncate mb-0" }, "Total Emplacements")
                ], -1)),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("h5", _hoisted_17, [
                    _cache[5] || (_cache[5] = _createElementVNode("i", { class: "ri-arrow-right-up-line fs-13 align-middle" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.stats.totalEmplacements), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", null, [
                  _createElementVNode("h4", _hoisted_19, [
                    _createElementVNode("span", {
                      class: "counter-value",
                      "data-target": _ctx.stats.totalEmplacements
                    }, _toDisplayString(_ctx.stats.totalEmplacements), 9, _hoisted_20)
                  ]),
                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "badge bg-info-subtle text-info mb-0" }, [
                    _createElementVNode("i", { class: "ri-arrow-up-line align-middle" }),
                    _createTextVNode(" Occupés ")
                  ], -1))
                ]),
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "avatar-sm flex-shrink-0" }, [
                  _createElementVNode("span", { class: "avatar-title bg-info-subtle rounded fs-3" }, [
                    _createElementVNode("i", { class: "bx bx-building text-info" })
                  ])
                ], -1))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "flex-grow-1 overflow-hidden" }, [
                  _createElementVNode("p", { class: "text-uppercase fw-medium text-muted text-truncate mb-0" }, "Arrièrés non payés")
                ], -1)),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("h5", _hoisted_26, [
                    _cache[9] || (_cache[9] = _createElementVNode("i", { class: "ri-arrow-right-up-line fs-13 align-middle" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.formatCurrency(_ctx.stats.arrriersTotal)), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", null, [
                  _createElementVNode("h4", _hoisted_28, [
                    _createElementVNode("span", {
                      class: "counter-value",
                      "data-target": _ctx.stats.arrriersTotal
                    }, _toDisplayString(_ctx.formatCurrency(_ctx.stats.arrriersTotal)), 9, _hoisted_29)
                  ]),
                  _cache[11] || (_cache[11] = _createElementVNode("span", { class: "badge bg-warning-subtle text-warning mb-0" }, [
                    _createElementVNode("i", { class: "ri-arrow-up-line align-middle" }),
                    _createTextVNode(" En attente ")
                  ], -1))
                ]),
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "avatar-sm flex-shrink-0" }, [
                  _createElementVNode("span", { class: "avatar-title bg-warning-subtle rounded fs-3" }, [
                    _createElementVNode("i", { class: "bx bx-money text-warning" })
                  ])
                ], -1))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "flex-grow-1 overflow-hidden" }, [
                  _createElementVNode("p", { class: "text-uppercase fw-medium text-muted text-truncate mb-0" }, "Revenus Totaux")
                ], -1)),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("h5", _hoisted_35, [
                    _cache[13] || (_cache[13] = _createElementVNode("i", { class: "ri-arrow-right-up-line fs-13 align-middle" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.formatCurrency(_ctx.stats.revenusTotaux)), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", null, [
                  _createElementVNode("h4", _hoisted_37, [
                    _createElementVNode("span", {
                      class: "counter-value",
                      "data-target": _ctx.stats.revenusTotaux
                    }, _toDisplayString(_ctx.formatCurrency(_ctx.stats.revenusTotaux)), 9, _hoisted_38)
                  ]),
                  _cache[15] || (_cache[15] = _createElementVNode("span", { class: "badge bg-danger-subtle text-danger mb-0" }, [
                    _createElementVNode("i", { class: "ri-arrow-up-line align-middle" }),
                    _createTextVNode(" Cumulé ")
                  ], -1))
                ]),
                _cache[16] || (_cache[16] = _createElementVNode("div", { class: "avatar-sm flex-shrink-0" }, [
                  _createElementVNode("span", { class: "avatar-title bg-danger-subtle rounded fs-3" }, [
                    _createElementVNode("i", { class: "bx bx-trending-up text-danger" })
                  ])
                ], -1))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "card-header" }, [
              _createElementVNode("h4", { class: "card-title mb-0" }, "Évolution des Paiements (12 derniers mois)")
            ], -1)),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("canvas", _hoisted_42, null, 512)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _cache[18] || (_cache[18] = _createElementVNode("div", { class: "card-header" }, [
              _createElementVNode("h4", { class: "card-title mb-0" }, "Répartition par Secteur")
            ], -1)),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("canvas", _hoisted_46, null, 512)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("div", _hoisted_48, [
            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "card-header" }, [
              _createElementVNode("h4", { class: "card-title mb-0" }, "Statut des Usagers")
            ], -1)),
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("canvas", _hoisted_50, null, 512)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("div", _hoisted_52, [
            _cache[20] || (_cache[20] = _createElementVNode("div", { class: "card-header" }, [
              _createElementVNode("h4", { class: "card-title mb-0" }, "Top 5 Secteurs")
            ], -1)),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("canvas", _hoisted_54, null, 512)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, [
            _cache[21] || (_cache[21] = _createElementVNode("div", { class: "card-header" }, [
              _createElementVNode("h4", { class: "card-title mb-0" }, "Répartition Géographique par Marché")
            ], -1)),
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("canvas", _hoisted_58, null, 512)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("div", _hoisted_60, [
            _cache[22] || (_cache[22] = _createElementVNode("div", { class: "card-header" }, [
              _createElementVNode("h4", { class: "card-title mb-0" }, "Paiements locatifs par Mois")
            ], -1)),
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("canvas", _hoisted_62, null, 512)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_63, [
          _createElementVNode("div", _hoisted_64, [
            _cache[23] || (_cache[23] = _createElementVNode("div", { class: "card-header" }, [
              _createElementVNode("h4", { class: "card-title mb-0" }, "Paiements autres recettes par Mois")
            ], -1)),
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("canvas", _hoisted_66, null, 512)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_67, [
          _createElementVNode("div", _hoisted_68, [
            _cache[25] || (_cache[25] = _createElementVNode("div", { class: "card-header" }, [
              _createElementVNode("h4", { class: "card-title mb-0" }, "Statistiques Détaillées")
            ], -1)),
            _createElementVNode("div", _hoisted_69, [
              _createElementVNode("div", _hoisted_70, [
                _createElementVNode("table", _hoisted_71, [
                  _cache[24] || (_cache[24] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Indicateur"),
                      _createElementVNode("th", null, "Valeur"),
                      _createElementVNode("th", null, "Évolution"),
                      _createElementVNode("th", null, "Tendance")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statsDetail, (stat, key) => {
                      return (_openBlock(), _createElementBlock("tr", { key: key }, [
                        _createElementVNode("td", null, _toDisplayString(stat.label), 1),
                        _createElementVNode("td", null, _toDisplayString(stat.value), 1),
                        _createElementVNode("td", null, _toDisplayString(stat.evolution) + "%", 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", {
                            class: _normalizeClass(stat.tendance === 'positive' ? 'text-success' : 'text-danger')
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass(stat.tendance === 'positive' ? 'ri-arrow-up-line' : 'ri-arrow-down-line')
                            }, null, 2),
                            _createTextVNode(" " + _toDisplayString(stat.tendance === 'positive' ? 'Hausse' : 'Baisse'), 1)
                          ], 2)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ])
      ]))
}